@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

.tooltip {
  @include blur(25px);
  position: absolute;
  border-radius: 10px;
  background: var(--light-80);
  box-shadow: 0.5px 0.5px 0px 0px #fff inset, 0px 6px 32px 0px rgba(0, 0, 0, 0.15);
  flex-shrink: 0;
  width: 115px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  pointer-events: none;
  opacity: 1;
  padding: 6px 12px;

  &.compact {
    gap: 5px;
    width: 102px;
    padding: 10px;

    .value h4 {
      font-weight: 700;
      font-size: 24px;
    }
  }

  .value {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }
}
